import styled from '@emotion/styled'
import { Stepper } from '@mui/material'
import { styled as muiStyled } from '@mui/system'
import { colors } from '@global/constants/colors'

export const CustomStepConnector = muiStyled(Stepper)(({ theme }: any) => ({
  padding: 0,
  '& .MuiStepConnector-active': {
    '& .MuiStepConnector-line': {
      backgroundImage: `linear-gradient(95deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`,
    },
  },
  '& .MuiStepConnector-root': {
    top: 19,
    padding: '0 20px',
    '&.Mui-completed .MuiStepConnector-line': {
      backgroundColor: theme.palette.success.main,
    },
  },
  '& .MuiStepConnector-line': {
    backgroundColor: '#9E9E9E',
    height: 2,
    border: 0,
  },
  '& .MuiStepLabel-label': {
    color: theme.text.gray,
    '&.Mui-error': {
      color: theme.text.gray,
    },
  },
  '& .MuiSvgIcon-root': {
    height: 24,
    width: 24,
    marginTop: 8,
    '&.Mui-completed': {
      color: theme.palette.success.main,
    },
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  },
}))

export const CircleErrorIcon = styled.div`
  background-color: #f44336;
  height: 40px;
  width: 40px;
  border-radius: 20px;
  text-align: center;
`

export const Timestamp = styled.div`
  margin-top: 4px;
  font-style: italic;
  font-size: 11px;
  color: ${colors.gray.medium};
`

export const StepperContainer = styled.div`
  width: 100%;
  min-width: 540px;
  padding: 0;
`
